import { Instance } from 'mobx-state-tree'
import { LessonChapterProgressModelBase } from './LessonChapterProgressModel.base'

/* The TypeScript type of an instance of LessonChapterProgressModel */
export interface LessonChapterProgressModelType extends Instance<typeof LessonChapterProgressModel.Type> {}

/* A graphql query fragment builders for LessonChapterProgressModel */
export {
  selectFromLessonChapterProgress,
  lessonChapterProgressModelPrimitives,
  LessonChapterProgressModelSelector
} from './LessonChapterProgressModel.base'

/**
 * LessonChapterProgressModel
 */
export const LessonChapterProgressModel = LessonChapterProgressModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
